// extracted by mini-css-extract-plugin
export var internalNoteEditor = "_g4-1";
export var quotedThread = "_g4-0";